<template>
  <div class="myCollectionGroup">
    <button v-if="isStaff"
      type="button"
      class="btn btnRound sizeXs btnCompare"
      :style="{borderColor: pointColor, backgroundColor: pointColor}"
      @mouseenter.prevent
      @click="openCompare">
      마이콜렉션
      <span>비교 담기</span>
    </button>
    <div class="collectionGroupTable" :style="{borderColor: styles.borderColor}">
      <div class="groupHeader" :style="{...classHeaderStyles, borderColor: styles.borderColor}">
        <div v-for="classItem in classes"
          :key="classItem.collectionClassId"
          class="classHeader"
          :style="{borderColor: styles.borderColor}">
          {{ classItem.collectionClassName[lang] }}
        </div>
      </div>

      <div v-for="item in normalizedItems"
        :key="item.orderItemId || item.collectionItemId"
        class="groupRow"
        :style="{borderColor: styles.borderColor}">
        <div class="groupItemName">
          <div class="nameWrap">
            <span v-if="getItemFlag(item.myCollectionFlag)" class="flag" :style="{backgroundColor: getItemFlag(item.myCollectionFlag)}"></span>
            <span class="name">{{ item.myCollectionName }}</span>
          </div>
          <button
            type="button"
            class="btn btnRound sizeXs"
            :style="{borderColor: pointColor, backgroundColor: pointColor}"
            @click="$emit('deleteItem', item.orderItemId)">
            삭제하기
          </button>
        </div>
        <div v-for="classItem in item.classItems"
          :key="classItem.collectionClassId"
          class="classCell">
          <CollectionGroupItem v-for="subItem in classItem.selectedSubItems"
            :key="subItem.orderItemId || subItem.subItemId"
            :locale="locale"
            :lang="lang"
            :item="subItem"
            :categoryId="categoryId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollectionGroupItem from './MyCollectionGroupItem'

export default {
  name: 'CollectionGroup',
  props: [
    'locale',
    'lang',
    'categoryId',
    'group',
    'isStaff'
  ],
  components: {
    CollectionGroupItem
  },
  computed: {
    setting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    classHeaderStyles () {
      const myCollectionSetting = this.getMyCollectionSetting
      const backgroundColor = myCollectionSetting && myCollectionSetting.backgroundColor
      return {
        backgroundColor: backgroundColor
      }
    },
    styles () {
      const setting = this.setting
      const category = setting && setting.category
      return {
        borderColor: category && category.borderColor,
      }
    },
    pointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    classes () {
      const map = {}

      ;(this.group.items || []).forEach(item => {
        ;(item.subItems || []).forEach(classItem => {
          const classId = classItem.collectionClassId

          if (!classId || map[classId]) return

          map[classId] = {
            collectionClassId: classId,
            collectionClassName: classItem.collectionClassName,
            isRequired: classItem.isRequired
          }
        })
      })
      return Object.values(map)
    },
    normalizedItems () {
      return (this.group.items || []).map(item => {
        const subItemMap = {}

        ;(item.subItems || []).forEach(classItem => {
          subItemMap[classItem.collectionClassId] = classItem
        })

        return {
          ...item,
          classItems: this.classes.map(classItem => {
            const matched = subItemMap[classItem.collectionClassId]

            return matched || {
              collectionClassId: classItem.collectionClassId,
              collectionClassName: classItem.collectionClassName,
              selectedSubItems: []
            }
          })
        }
      })
    },
    isGroupCategory () {
      return this.$store.getters['collection/getMyCollectionIsGroupCategory']
    },
  },
  methods: {
    getItemFlag (flagId) {
      const flags = this.$store.getters['collection/getMyCollectionFlags']
      const findFlag = flags.find(flag => flag.id === flagId)
      return findFlag ? findFlag.value : null
    },
    getClassSubItems (item, classId) {
      const classItem = (item.subItems || []).find(subItem => {
        return subItem.collectionClassId === classId
      })

      return classItem ? classItem.selectedSubItems || [] : []
    },
    getInitialSelectedClassItems() {
      const selected = {}

      this.normalizedItems.forEach(item => {
        item.classItems.forEach(classItem => {
          if (!selected[classItem.collectionClassId]) {
            selected[classItem.collectionClassId] = {
              collectionClassId: classItem.collectionClassId,
              collectionClassName: classItem.collectionClassName,
              // parentOrderItemId: item.orderItemId,
              // selectedSubItems: [...classItem.selectedSubItems]
              parentOrderItemId: '',
              selectedSubItems: []
            }
          }
        })
      })

      return selected
    },
    openCompare() {
      this.$store.commit('collection/setMyCollectionCompare', {
        group: this.group,
        classes: this.classes,
        items: this.normalizedItems,
        selectedClassItems: this.getInitialSelectedClassItems()
      })
    }
  }
}
</script>